import { render, staticRenderFns } from "./WhatsappWeb.vue?vue&type=template&id=89b846ec&scoped=true&"
import script from "./WhatsappWeb.vue?vue&type=script&lang=js&"
export * from "./WhatsappWeb.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappWeb.vue?vue&type=style&index=0&id=89b846ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b846ec",
  null
  
)

export default component.exports